import { useMutation } from "@tanstack/react-query";
import { ICancelOpenGymReservation, ICreateOpenGymReservation } from "../../models/OpenGym";
import { OpenGymService } from "../../services/open-gym.service";

export const useOpenGymMutations = () => {
  const { mutate: createOpenGymReservation } = useMutation<any, Error, ICreateOpenGymReservation>({
    mutationFn: async (data: ICreateOpenGymReservation) =>
      OpenGymService.createOpenGymReservation(data).then((res) => res.data),
  });

  const { mutate: cancelOpenGymReservation } = useMutation<any, Error, ICancelOpenGymReservation>({
    mutationFn: async (data: ICancelOpenGymReservation) =>
      OpenGymService.cancelOpenGymReservation(data).then((res) => res.data),
  });

  return {
    createOpenGymReservation,
    cancelOpenGymReservation,
  };
};
